<!--  -->
<template>
  <div class="mask">
    <div class="content">
      <div class="title">资金存入凭证</div>
      <div class="flexr0c">
        <div class="sub-title1">受理时间: {{ proof.changeDate.year }}-{{ proof.changeDate.monthValue }}-{{ proof.changeDate.dayOfMonth }} {{ proof.changeDate.hour }}:{{ proof.changeDate.minute }}:{{ proof.changeDate.second }}</div>
        <div class="sub-title2">受理状态: 成功</div>
        <div class="sub-title3">交易流水号: {{ proof.infundBean.tradeNo }}</div>
      </div>
      <div class="table">
        <div class="flexr0c">
          <div class="label">付款账户名</div>
          <div class="item">{{ proof.fromName }}</div>
          <div class="label">收款账户名</div>
          <div class="item">{{ proof.taxName }}</div>
        </div>
        <div class="flexr0c">
          <div class="label">付款账户</div>
          <div class="item">{{ proof.paymentAccount }}</div>
          <div class="label">收款账户</div>
          <div class="item">{{ proof.vaAccount }}</div>
        </div>
        <div class="flexr0c">
          <div class="label">付款开户行</div>
          <div class="item">{{ proof.fromBkname }}</div>
          <div class="label">付款企业</div>
          <div class="item">{{ proof.enterpriseName }}</div>
        </div>
        <div class="flexr0c">
          <div class="label">金额(大写)</div>
          <div class="item">{{ proof.CAPITAL }}</div>
          <div class="label">金额(小写)</div>
          <div class="item">￥{{ proof.changeMoney }}</div>
        </div>
        <div class="flexr0c">
          <div class="big-label">安全信息</div>
          <div class="big-item1">{{ proof.SECURE_CODE }}</div>
          <div class="big-item2"></div>
        </div>
      </div>
      <div class="tips">注：该凭证仅为转账流水单，不做任何其他依据</div>
      <div class="flexrbc bottom-txt">
        <div class="flexr0c">
          <img src="../assets/imgs/home/comlogo.png" alt="" />
          <div class="company">中资云企业综合服务平台</div>
        </div>
        <div class="website">企业服务网站：http://fw.hnfmkyw.cn</div>
      </div>
      <div class="btn" @click="printPage">打印</div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      proof: {
        changeDate: {},
        infundBean: {},
        tradeRecordBean: {},
      },
      index: -1,
    };
  },
  computed: {},
  watch: {},
  methods: {
    getCertificate() {
      var session = JSON.parse(localStorage["session"]);
      var data = {
        sessionId: session.sessionId,
        userId: session.userId,
        modeCode: "AcxniMm970m5sH9WeCQjpAj6Oi8uznJu",
        id: this.index,
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.proof = res.data;
        } else {
          this.$Message["error"]({
            background: true,
            content: res.msg,
          });
        }
      });
    },
    printPage() {
      window.print();
      this.$router.back();
    },
  },
  created() {
    this.index = this.$route.params.index;
    this.getCertificate();
  },
};
</script>

<style lang="less" scoped>
.mask {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: #fff;
  z-index: 10;

  .content {
    width: 920px;
    position: relative;

    .title {
      font-family: PingFangSC-Semibold;
      font-size: 22px;
      color: #000000;
      letter-spacing: 0;
      text-align: center;
      margin: 140px 0 32px 0;
    }

    .sub-title1,
    .sub-title2,
    .sub-title3 {
      flex: 1;
      text-align: start;
      font-family: PingFangSC-Semibold;
      font-size: 10px;
      color: #000000;
      letter-spacing: 0;
      margin: 0 0 9px 9px;
    }

    .sub-title2 {
      text-align: center;
      margin: 0;
    }

    .sub-title3 {
      text-align: end;
      margin: 0 9px 9px 0;
    }

    .table {
      border: 1px solid #000;
      height: 400px;

      & > div {
        border-bottom: 1px solid #000;
        height: 40px;
        width: 100%;

        .label {
          width: 123px;
          height: 40px;
          line-height: 40px;
          border-right: 1px solid #000;
          font-family: PingFangSC-Semibold;
          font-size: 12px;
          color: #000000;
          letter-spacing: 0;
          text-align: center;
        }

        .big-label {
          width: 123px;
          height: 239px;
          line-height: 239px;
          border-right: 1px solid #000;
          font-family: PingFangSC-Semibold;
          font-size: 12px;
          color: #000000;
          letter-spacing: 0;
          text-align: center;
        }

        .item {
          width: 336px;
          height: 40px;
          line-height: 40px;
          text-align: start;
          padding-left: 10px;
          font-family: PingFangSC-Semibold;
          font-size: 12px;
          color: #000000;
          letter-spacing: 0;
        }

        .big-item1 {
          width: 459px;
          height: 239px;
          border-right: 1px solid #000;
          text-align: start;
          padding-left: 10px;
          padding-top: 5px;
          font-family: PingFangSC-Semibold;
          font-size: 12px;
          color: #000000;
          letter-spacing: 0;
        }

        .big-item2 {
          width: 336px;
          height: 239px;
          text-align: start;
          padding-left: 10px;
          padding-top: 5px;
          font-family: PingFangSC-Semibold;
          font-size: 12px;
          color: #000000;
          letter-spacing: 0;
        }

        .item:nth-child(2) {
          border-right: 1px solid #000;
        }
      }

      & > div:last-child {
        border-bottom: none;
        height: 239px;
      }
    }

    .tips {
      position: absolute;
      transform: translate(0, -30px);
      left: 135px;
    }

    .bottom-txt {
      width: 900px;
      margin-left: 10px;
      margin-top: 10px;
    }

    .btn {
      background-image: linear-gradient(180deg, #478ee9 0%, #2255ce 100%);
      border: 1px solid #285ed3;
      border-radius: 8px;
      font-family: PingFangSC-Semibold;
      font-size: 18px;
      color: #ffffff;
      letter-spacing: 0.34px;
      width: 368px;
      height: 48px;
      line-height: 48px;
      text-align: center;
      margin: 160px auto 0 auto;
      cursor: pointer;
    }
  }
}
@media print {
  .btn {
    display: none;
  }
}
</style>
